module.exports = __webpack_public_path__ + "public/SiteImages/noReservation.svg?1edc73e1";